// The height of the fixed object header (including the bottom border) is needed for SSR for
// certain routes (such as Databases), when they can't use ResizeObserver to tell them how big the
// header actually is
export const FIXED_OBJECT_HEADER_SSR_HEIGHT = 57;
